import { createContext } from 'react';

const ModalContext = createContext({
  onClose: () => {
    // do nothing
  },
});

export { ModalContext };
